import React, {useState, useEffect} from "react";
import ApiService from "../../services/api-service";
import Footer from "../../component/footer";
import SideMenu from "../../component/side-menu";
import MobileMenuButton from "../../component/mobile-menu-button";
import {useParams} from "react-router-dom";

const api = new ApiService();

const NewsEdit = () => {
    const {id} = useParams();
    const [form, setForm] = useState({});
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        api.getNews(id)
            .then(x => {
                if (x.response) {
                    setForm(x.response);
                }
            })
            .catch();
    }, [id]);

    const updateNews = (e) => {
        e.preventDefault();
        api.updateNews(id, form)
            .then(x => {
                if (x.code === 100) {
                    setSuccess(true);
                    setForm({
                        title: '',
                        category: '',
                        desc: '',
                    });
                }
            })
            .catch();
    };

    return (
        <div id="app">

            <SideMenu active={'news'}/>

            <div id="main">
                <MobileMenuButton />

                <div className="page-heading">
                    <div className="page-title">
                        <div className="row">
                            <div className="col-12 col-md-6 order-md-1 order-last">
                                <h3>Edit News</h3>
                            </div>
                        </div>
                    </div>

                    <section id="basic-horizontal-layouts">
                        <div className="row match-height">
                            <div className="col-md-12 col-12">
                                <div className="card">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <form className="form form-horizontal" onSubmit={updateNews}>
                                                <div className="form-body">

                                                    <div className="row">

                                                        <div className="col-md-4">
                                                            <label>Title</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group has-icon-left">
                                                                <div className="position-relative">
                                                                    <input type="text" className="form-control"
                                                                           placeholder="Title"
                                                                           value={form.title}
                                                                           onChange={(e) => setForm((o) => ({
                                                                               ...o,
                                                                               title: e.target.value
                                                                           }))}
                                                                           id="first-name-icon"/>
                                                                    <div className="form-control-icon">
                                                                        <i className="bi bi-align-top"/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>Category</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group has-icon-left">
                                                                <div className="position-relative">
                                                                    <select className="form-control"
                                                                           value={form.category}
                                                                           onChange={(e) => setForm((o) => ({
                                                                               ...o,
                                                                               category: e.target.value
                                                                           }))}
                                                                    >
                                                                        <option value={''}>Select</option>
                                                                        <option value={'GENERAL'}>GENERAL</option>
                                                                    </select>
                                                                    <div className="form-control-icon">
                                                                        <i className="bi bi-card-checklist"/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>Description</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group has-icon-left">
                                                                <div className="position-relative">
                                                                    <textarea className="form-control"
                                                                           placeholder="Description"
                                                                           value={form.desc}
                                                                           onChange={(e) => setForm((o) => ({
                                                                               ...o,
                                                                               desc: e.target.value
                                                                           }))}
                                                                    />
                                                                    <div className="form-control-icon">
                                                                        <i className="bi bi-card-text"/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>Status</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group has-icon-left">
                                                                <div className="position-relative">
                                                                    <select className="form-control"
                                                                              value={form.active}
                                                                              onChange={(e) => setForm((o) => ({
                                                                                  ...o,
                                                                                  active: e.target.value
                                                                              }))}
                                                                    >
                                                                        <option value={''}>Select</option>
                                                                        <option value={'true'}>Active</option>
                                                                        <option value={'false'}>Passive</option>
                                                                    </select>
                                                                    <div className="form-control-icon">
                                                                        <i className="bi bi-card-text"/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 d-flex justify-content-end">
                                                            <button type="submit" className="btn btn-primary me-1 mb-1">
                                                                Submit
                                                            </button>
                                                        </div>

                                                        {success && (
                                                        <div className="alert alert-light-success color-success" style={{marginTop: 20}}>
                                                            <i className="bi bi-check-circle"/> News updated successfully.
                                                        </div>)}

                                                    </div>

                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>

                <Footer/>
            </div>
        </div>
    );

};

export default NewsEdit;
